<template>
    <v-container fluid>
        <v-dialog
            v-if="invoiceDataDialogStatus"
            v-model="invoiceDataDialogStatus"
            max-width="90vw"
            transition="dialog-bottom-transition"
            persistent
            fullscreen
        >
            <v-card>
                <v-card-title style="margin-bottom: 20px;">
                    <v-row class="d-flex align-center" style="justify-content: space-between;">
                        <v-col cols="auto">
                            <h3>Invoice: {{ typeof invoice.invoice_number !== 'undefined' ? invoice.invoice_number : '' }}</h3>
                        </v-col>
                        <v-col cols="auto">
                            <v-icon
                                color="indigo"
                                @click="closeInvoiceData"
                            >
                                mdi-close-circle
                            </v-icon>
                        </v-col>
                        <!-- <v-col cols="12" md="6">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-btn
                                        color="info"
                                        dark
                                        depressed
                                        @click="
                                            downloadExpenseReport(
                                                invoice.expenses
                                            )
                                        "
                                    >
                                        <v-icon left>mdi-file-download</v-icon>
                                        Download
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-btn
                                        color="error"
                                        dark
                                        depressed
                                        @click="invoiceDialog = false"
                                    >
                                        <v-icon left>mdi-close</v-icon>
                                        Close
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col> -->
                    </v-row>
                </v-card-title>
                <v-card-text v-if="invoice != {}">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.invoice_number"
                                        label="Invoice Number"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.purchase_order_number"
                                        label="Purchase Order Number"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.subtotal_cost"
                                        label="Subtotal Cost"
                                        prefix="$"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.total_cost"
                                        label="Total Cost"
                                        prefix="$"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.invoice_issued_at"
                                        label="Invoice Date"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" v-if="type.axios !== 'supplies'">
                                    <v-text-field
                                        v-if="type.axios == 'trucks'"
                                        v-model="invoice.model.Truck"
                                        label="Unit"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                    <v-text-field
                                        v-else-if="type.axios == 'trailers'"
                                        v-model="invoice.model.Trailer"
                                        label="Unit"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.maintenance_ended_at"
                                        label="Maintenance Ended At"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.maintenance_started_at"
                                        label="Maintenance Started At"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.tax_region.name"
                                        label="Tax Region"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.region.PrincipalRegion"
                                        label="Region"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.company.CompanyName"
                                        label="Company"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.vendor.name"
                                        label="Vendor"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.user.name"
                                        label="User"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="invoice.hub_reading"
                                        label="Hub Reading"
                                        readonly
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-btn
                                        class="ma-2"
                                        outlined
                                        color="teal"
                                        @click="viewInvoiceFile(invoice)"
                                    >
                                        View invoice file
                                        <v-icon
                                            right
                                            dark
                                        >
                                            mdi-file-eye-outline
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-data-table
                                fixed-header
                                :headers="expenseHeaders"
                                :items="invoice.expenses"
                                disable-pagination
                                hide-default-footer
                                class="elevation-1"
                                group-by="maintenance_expense_category_id"
                            >
                                <template
                                    v-slot:group.header="{ items, group }"
                                    style="cursor: crosshair; background-color: #e8eaf6"
                                >
                                    <td style="text-align: left;">
                                        <v-btn
                                            text
                                            left
                                            color="indigo"
                                            @click="toggleGroup(group)"
                                        >
                                            <v-icon>
                                                {{
                                                    groupOpenState[group]
                                                        ? 'mdi-minus'
                                                        : 'mdi-plus'
                                                }}
                                            </v-icon>
                                            Category:
                                            {{ items[0].category.name }}
                                        </v-btn>
                                        <!-- <v-tooltip right color="success">
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    right
                                                    color="success"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="
                                                        downloadExpenseReport(
                                                            items
                                                        )
                                                    "
                                                >
                                                    mdi-file-chart
                                                </v-icon>
                                            </template>
                                            <span
                                                >Download
                                                {{ items[0].category.name }}
                                                Expenses report</span
                                            >
                                        </v-tooltip> -->
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style="text-align: left;">
                                        {{ expenseTotals(items).subTotalCost }}
                                    </td style="text-align: left;">
                                    <td style="text-align: left;">{{ expenseTotals(items).tax }}</td>
                                    <td style="text-align: left;">
                                        {{ expenseTotals(items).totalCost }}
                                    </td>
                                </template>
                                <template v-slot:item="{ item }">
                                    <tr
                                        v-if="
                                            groupOpenState[
                                                item
                                                    .maintenance_expense_category_id
                                            ]
                                        "
                                    >
                                        <td style="text-align: left;">{{ item.category.name }}</td>
                                        <td style="text-align: left;">
                                            {{
                                                item.subcategory
                                                    ? item.subcategory.name
                                                    : 'N/A'
                                            }}
                                        </td>
                                        <td style="text-align: left;">{{ item.description }}</td>
                                        <td style="text-align: left;">{{ item.custom_tax_rate }}</td>
                                        <td style="text-align: left;">{{ item.quantity }}</td>
                                        <td style="text-align: left;">${{ item.unit_cost }}</td>
                                        <td style="text-align: left;">
                                            {{
                                                item.subtotal_cost
                                                    ? '$' + item.subtotal_cost
                                                    : expenseTotals(item)
                                                          .subTotalCost
                                            }}
                                        </td>
                                        <td style="text-align: left;">${{ item.tax }}</td>
                                        <td style="text-align: left;">${{ item.total_cost }}</td>
                                    </tr>
                                </template>
                                <template v-slot:foot="{ items }">
                                    <!-- <td>
                                        <v-btn
                                            color="success"
                                            text
                                            class="ma-2"
                                            @click="
                                                downloadExpenseReport(items)
                                            "
                                        >
                                            <v-icon left
                                                >mdi-chart-box-multiple</v-icon
                                            >
                                            Download Expense Report
                                        </v-btn>
                                    </td> -->
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="px-4" style="text-align: left;">
                                        <strong>{{ expenseTotals(items).subTotalCost }}</strong>
                                    </td>
                                    <td class="px-4" style="text-align: left;">
                                        <strong>{{ expenseTotals(items).tax }}</strong>
                                    </td>
                                    <td class="px-4" style="text-align: left;">
                                        <strong>{{ expenseTotals(items).totalCost }}</strong>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="invoiceFileView" fullscreen>
            <v-card>
                <v-toolbar color="secondary" dense dark>
                    <v-spacer></v-spacer>
                    <v-card-title primary-title>Invoice Document View</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon left @click="invoiceFileView = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-container grid-list-xs fluid>
                    <iframe :src="invoiceFileLink" style="width: 100%; height:100vh ;"></iframe>
                </v-container>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        invoiceDataDialogStatus: {
            type: Boolean,
            required: true
        },
        invoice: Object,
        type: Object,
    },
    components: {

    },
    data: function () {
        return {
            expenseHeaders: [
                { text: 'Expense Category', value: 'category' },
                { text: 'Expense Subcategory', value: 'subcategory' },
                { text: 'Description', value: 'description' },
                { text: 'Tax Rate', value: 'custom_tax_rate' },
                { text: 'Quantity', value: 'quantity' },
                { text: 'Unit Cost', value: 'unit_cost' },
                { text: 'Subtotal Cost', value: 'subtotal_cost' },
                { text: 'Tax', value: 'tax' },
                { text: 'Total Cost', value: 'total_cost' }
            ],
            groupOpenState: {},
            invoiceFileView: false,
            invoiceFileLink: '',
        }
    },
    mounted() {
        this.invoice.expenses.forEach(item => {
            this.$set(
                this.groupOpenState,
                item.maintenance_expense_category_id,
                false
            );
        });
    },
    methods: {
        toggleGroup(group) {
            console.log('Group: ', group);
            if (
                Object.prototype.hasOwnProperty.call(this.groupOpenState, group)
            ) {
                this.groupOpenState[group] = !this.groupOpenState[group];
                console.log('Group open state: ', this.groupOpenState);
            }
        },
        expenseTotals(expenses, format = true) {
            //Return total costs and taxes for the expenses
            let totalCost = 0;
            let tax = 0;
            let subTotalCost = 0;
            //if there are multiple expenses run the foreach loop to get the total cost and tax else process the single expense that is not an array
            if (expenses.length > 0) {
                expenses.forEach(expense => {
                    //values are in text format, convert to numbers of no more than 2 decimal places, remember that these are currencies
                    let expenseTotalCost = parseFloat(expense.total_cost);
                    let expenseTax = parseFloat(expense.tax);
                    let expenseSubTotalCost = parseFloat(expense.subtotal_cost);
                    totalCost += expenseTotalCost;
                    tax += expenseTax;
                    subTotalCost += expenseSubTotalCost;
                });
            } else {
                let expense = expenses;
                let expenseTotalCost = parseFloat(expense.total_cost);
                let expenseTax = parseFloat(expense.tax);
                let expenseSubTotalCost = parseFloat(expense.subtotal_cost);
                totalCost += expenseTotalCost;
                tax += expenseTax;
                subTotalCost += expenseSubTotalCost;
            }
            totalCost = Math.round(totalCost * 100) / 100;
            tax = Math.round(tax * 100) / 100;
            subTotalCost = Math.round(subTotalCost * 100) / 100;
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            });

            if (format) {
                return {
                    subTotalCost: formatter.format(subTotalCost),
                    totalCost: formatter.format(totalCost),
                    tax: formatter.format(tax)
                };
            } else {
                return {
                    subTotalCost: subTotalCost,
                    totalCost: totalCost,
                    tax: tax
                };
            }
        },
        viewInvoiceFile(invoice) {
            console.log(invoice);
            if (!invoice.files.length) {
                this.$store.dispatch('setSnackbar', {
                    text: 'No files to view.',
                    color: 'warning'
                });
                return;
            }
            
            let params = {
                invoice: invoice,
            };
            this.$store.state.isLoading = true;
            axios
                .post('/v2/maintenance/invoices/files/view', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.invoiceFileLink = response.data;
                    this.invoiceFileView = true;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.$store.state.isLoading = false;
                })
        },
        closeInvoiceData() {
            this.invoiceFileView = false;
            this.invoiceDataDialogStatus = false;
        }
    },
};
</script>

<style>
/* Styles here */
</style>